import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './TS_PropRenderer.scss';
import { LL_H_B, LL_H_C, LL_H_T, LL_V_L } from '../Layouts/index.js';
import { _className } from '../../utils/tools.js';
import { resolveContent } from '@nu-art/ts-common';
const TS_PropRenderer_Horizontal = (props) => {
    const className = _className('ts-prop-renderer horizontal', props.disabled && 'disabled', props.className);
    const { label, error, ..._props } = props;
    let _LinearComponent;
    switch (props.verticalAlignment) {
        case 'top':
            _LinearComponent = LL_H_T;
            break;
        case 'bottom':
            _LinearComponent = LL_H_B;
            break;
        default:
            _LinearComponent = LL_H_C;
            break;
    }
    return _jsxs(_LinearComponent, { ..._props, className: className, children: [_jsxs("div", { className: 'ts-prop-renderer__label', children: [resolveContent(label), props.error && _jsx("div", { className: 'ts-prop-renderer__error', children: props.error })] }), props.children] });
};
const TS_PropRenderer_Vertical = (props) => {
    const className = _className('ts-prop-renderer vertical', props.disabled && 'disabled', props.className);
    const { label, error, ..._props } = props;
    return _jsxs(LL_V_L, { ..._props, className: className, children: [_jsxs("div", { className: 'ts-prop-renderer__label', children: [resolveContent(label), props.error && _jsx("div", { className: 'ts-prop-renderer__error', children: props.error })] }), props.children] });
};
const TS_PropRenderer_Flat = (props) => {
    const labelClass = _className('ts-prop-renderer__label', props.disabled && 'disabled', props.className);
    return _jsxs(_Fragment, { children: [_jsxs("div", { className: labelClass, children: [resolveContent(props.label), props.error && _jsx("div", { className: 'ts-prop-renderer__error', children: props.error })] }), props.children] });
};
export const TS_PropRenderer = {
    Vertical: TS_PropRenderer_Vertical,
    Horizontal: TS_PropRenderer_Horizontal,
    Flat: TS_PropRenderer_Flat,
};
//# sourceMappingURL=TS_PropRenderer.js.map